import { render, staticRenderFns } from "./TemporaryItemsTable.vue?vue&type=template&id=12b3fa8c&scoped=true"
import script from "./TemporaryItemsTable.vue?vue&type=script&lang=js"
export * from "./TemporaryItemsTable.vue?vue&type=script&lang=js"
import style0 from "./TemporaryItemsTable.vue?vue&type=style&index=0&id=12b3fa8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3fa8c",
  null
  
)

export default component.exports